var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('v-app',[_c('v-content',{staticStyle:{"width":"100vw","height":"100vh","margin":"0","padding":"0","background-color":"#e5e5e5"}},[_vm._t("default")],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }